var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShopIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.05477 8.31159L2.34746 23.8416C2.16216 25.5271 3.48198 27 5.17763 27H22.8229C24.5185 27 25.8383 25.5271 25.653 23.8416L23.9457 8.3116C23.787 6.86823 22.5676 5.77551 21.1155 5.77551H18.3336H9.70858H6.88494C5.43288 5.77551 4.21345 6.86823 4.05477 8.31159Z",
    fill: "url(#paint0_linear_11557_8004)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.70858 5.77551C9.70858 5.77551 9.32316 1 13.9482 1C18.5732 1 18.3336 5.77551 18.3336 5.77551M9.70858 5.77551H18.3336M9.70858 5.77551H6.88494C5.43288 5.77551 4.21345 6.86823 4.05477 8.31159L2.34746 23.8416C2.16216 25.5271 3.48198 27 5.17763 27H22.8229C24.5185 27 25.8383 25.5271 25.653 23.8416L23.9457 8.3116C23.787 6.86823 22.5676 5.77551 21.1155 5.77551H18.3336M9.70858 11.6122C9.70858 11.6122 8.93774 17.5079 13.9482 17.5079C18.9586 17.5079 18.3336 11.6122 18.3336 11.6122",
    stroke: "url(#paint1_linear_11557_8004)",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.70833 11.6121C9.70833 11.6121 8.9375 17.5078 13.9479 17.5078C18.9583 17.5078 18.3333 11.6121 18.3333 11.6121M5.17739 26.9999C3.48173 26.9999 2.16192 25.527 2.34722 23.8415L4.05453 8.31148C4.2132 6.86811 5.43264 5.77539 6.8847 5.77539M2.34722 23.8415C2.16192 25.527 3.48173 26.9999 5.17739 26.9999M4.05453 8.31148C4.2132 6.86811 5.43264 5.77539 6.8847 5.77539M6.8847 5.77539H9.70833H18.3333H21.1153M21.1153 5.77539C22.5674 5.77539 23.7868 6.86811 23.9455 8.31148M22.8226 26.9999C24.5183 26.9999 25.8381 25.527 25.6528 23.8415L23.9455 8.31148C23.7868 6.86811 22.5674 5.77539 21.1153 5.77539M25.6528 23.8415C25.8381 25.527 24.5183 26.9999 22.8226 26.9999M22.8226 26.9999H5.17739",
    stroke: "#101010",
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11557_8004",
    x1: -1.5924,
    y1: 54.95,
    x2: -25.5036,
    y2: 36.8477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D38F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E827D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11557_8004",
    x1: -1.5924,
    y1: 54.95,
    x2: -25.5036,
    y2: 36.8477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D38F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E827D9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopIcon);
export default __webpack_public_path__ + "static/media/shop_icon.f66a0152a0338ab70d7775bc01f997b7.svg";
export { ForwardRef as ReactComponent };